import { current } from '../helpers'
import { archiveTodoTodosetsPath, archiveTodoTodosetTodolistsPath } from '../routes'
import SelectAllController from './select_all_controller'

const TODOSETS_FRAME_ID = 'archive_todos_todosets'
const TODOLISTS_FRAME_ID = 'archive_todos_todolists'

export default class extends SelectAllController {
  static targets = [
    'projectSelect', 'submitButton', 'buttonCount',
    'projectStep', 'todosetStep', 'todolistStep'
  ]

  connect () {
    const tsFrame = document.getElementById(TODOSETS_FRAME_ID)
    if (tsFrame) this.initialTodosetsHTML = tsFrame.innerHTML
    const tlFrame = document.getElementById(TODOLISTS_FRAME_ID)
    if (tlFrame) this.initialTodolistsHTML = tlFrame.innerHTML
  }

  selectProject () {
    this.resetSubmitButton()
    this.resetTodolists()
    this.setStepState(this.todolistStepTarget, 'disabled')
    if (this.projectId) {
      this.loadTodosets()
      this.setStepState(this.projectStepTarget, 'done')
      this.setStepState(this.todosetStepTarget, 'active')
    } else {
      this.resetTodosets()
      this.setStepState(this.projectStepTarget, 'active')
      this.setStepState(this.todosetStepTarget, 'disabled')
    }
  }

  selectTodoset ({ target }) {
    this.loadTodolists(target.value)
    this.setStepState(this.todosetStepTarget, 'done')
    this.setStepState(this.todolistStepTarget, 'active')
    this.submitButtonVisible = true
    this.submitButtonDisabled = true
  }

  toggle (e) {
    this.checkboxTargets.forEach((checkbox) => {
      if (!checkbox.disabled && Number(checkbox.dataset.completedCount) > 0) {
        checkbox.checked = e.target.checked
        this.triggerInputEvent(checkbox)
      }
    })
    this.updateSubmitButtonState()
  }

  refresh () {
    super.refresh()
    this.updateSubmitButtonState()
  }

  loadTodosets () {
    const frame = document.getElementById(TODOSETS_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.cardsGridSkeleton())
    frame.src = archiveTodoTodosetsPath(current.account.id, this.projectId)
  }

  loadTodolists (todosetId) {
    const frame = document.getElementById(TODOLISTS_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.listSkeleton())
    frame.src = archiveTodoTodosetTodolistsPath(current.account.id, this.projectId, todosetId)
  }

  resetTodosets () {
    const frame = document.getElementById(TODOSETS_FRAME_ID)
    if (!frame || !this.initialTodosetsHTML) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialTodosetsHTML
  }

  resetTodolists () {
    const frame = document.getElementById(TODOLISTS_FRAME_ID)
    if (!frame || !this.initialTodolistsHTML) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialTodolistsHTML
  }

  updateSubmitButtonState () {
    const count = this.checked.length
    this.submitButtonDisabled = count === 0
    this.buttonCountContent = count
  }

  // eslint-disable-next-line accessor-pairs
  set buttonCountContent (count) {
    if (!this.hasButtonCountTarget) return
    this.buttonCountTarget.textContent = count === 1
      ? '1 list'
      : `${count} lists`
  }
}
